import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear(); // Get the current year dynamically

  return (
    <footer className="bg-gray-800 text-white p-4 text-center fixed bottom-0 left-0 w-full z-10">
      <p>© {currentYear} OpenCallForArtists. All Rights Reserved By ArtsToHeartsProject</p>
    </footer>
  );
};

export default Footer;